import {
  IconButton,
  Checkbox,
  HStack,
  useDisclosure,
  Box,
  Modal,
  ModalOverlay,
  Text,
  ModalContent,
  ModalHeader,
  Flex,
  ModalCloseButton,
  ModalBody,
  Center,
  Button,
  Table,
  Thead,
  Tr,
  Th,
  Td,
  Tbody,
  Divider,
  Tab,
  Tabs,
  TabPanel,
  TabPanels,
  TabList
} from '@chakra-ui/react'
import { format, parseISO } from 'date-fns'
import { FC, useMemo } from 'react'
import Highlighter from 'react-highlight-words'

import useParametrizationSimilarProduct from '@hook/parametrization/use-similar-product'
import useTableScrollProductSimilar from '@hook/shared/use-table-product-similar-scroll'

import LayoutLoader from '@component/Layout/Loader'

import { ITableGridRow } from '@base/@types/components/Layout/TableGrid'

const TableGridParametrizationIncrementItem: FC<{ [key: string]: any }> = ({
  data
}) => {
  const { actions, columns, query } = useTableScrollProductSimilar()
  const { getHistoricUpdate, loadingModalHistoricUpdate, dataHistoricUpdate } =
    useParametrizationSimilarProduct()
  const { isOpen, onOpen, onClose } = useDisclosure()

  const rows = useMemo<ITableGridRow[]>(() => {
    const res = []
    for (const column of columns) {
      if (column.columns && column.columns.length > 0) {
        for (const row of column.columns) {
          res.push({
            id: row.id,
            value: data[row.id],
            align: row.align || 'left',
            isNumeric: row.isNumeric
          })
        }
      } else {
        res.push({
          id: column.id!,
          value: data[column.canPrint ? column.id! : column.group],
          align: column.align || 'left'
        })
      }
    }
    return res
  }, [columns, data])
  return (
    <tr>
      {actions && actions.length > 0 && (
        <td>
          <HStack
            spacing={2}
            w="100%"
            alignItems="center"
            justifyContent="center"
          >
            {actions.map((action, index) => {
              if (action.type === 'default') {
                return (
                  <IconButton
                    key={`table-action-${index}`}
                    aria-label="Abrir modal s"
                    icon={action.icon}
                    size="xs"
                    onClick={() => action.onSelect!(data)}
                  />
                )
              }
              if (action.type === 'icon') {
                return (
                  <>
                    <Modal
                      isCentered
                      isOpen={isOpen}
                      onClose={onClose}
                      scrollBehavior="inside"
                      motionPreset="slideInBottom"
                      colorScheme="white"
                      size="6xl"
                    >
                      <ModalOverlay />
                      <ModalContent
                        background={'white'}
                        marginLeft={[4, 8, 16]}
                        marginRight={[4, 8, 16]}
                      >
                        <ModalHeader
                          paddingTop={2}
                          paddingBottom={2}
                          paddingLeft={4}
                          paddingRight={4}
                          textColor={'gray.200'}
                          background={'#1d5840'}
                          borderTopLeftRadius={5}
                          borderTopRightRadius={5}
                          borderBottom="3px solid #ECC94B"
                        >
                          <Flex alignItems="center">
                            <Text marginLeft={2}>Histórico</Text>
                          </Flex>
                        </ModalHeader>
                        <ModalCloseButton
                          top={1}
                          right={1.5}
                          textColor={'gray.200'}
                          size="lg"
                        />
                        <ModalBody bg="white">
                          {loadingModalHistoricUpdate ? (
                            <LayoutLoader
                              type="modal"
                              title="Recuperando informações..."
                              message="Aguarde enquanto buscamos os registros no banco de dados"
                            />
                          ) : (
                            <>
                              {dataHistoricUpdate.length > 0 ? (
                                <Tabs variant="enclosed">
                                  <TabList>
                                    {dataHistoricUpdate.length > 0 ? (
                                      <Tab>Histórico</Tab>
                                    ) : (
                                      <></>
                                    )}
                                  </TabList>

                                  <TabPanels>
                                    {dataHistoricUpdate.length > 0 && (
                                      <TabPanel>
                                        {loadingModalHistoricUpdate ? (
                                          <LayoutLoader
                                            type="modal"
                                            title="Recuperando informações..."
                                            message="Aguarde enquanto buscamos os registros no banco de dados"
                                          />
                                        ) : (
                                          <>
                                            <Divider />
                                            <Text
                                              fontSize={'sm'}
                                              fontWeight="bold"
                                            >
                                              Dados das últimas alterações:
                                            </Text>
                                            <Text
                                              fontSize={'sm'}
                                              fontWeight="bold"
                                            >
                                              Centro: {data['empresa-id']} -{' '}
                                              {data['empresa-nome']}
                                            </Text>
                                            <Text
                                              fontSize={'sm'}
                                              fontWeight="bold"
                                              pb={6}
                                            >
                                              Produto Novo:{' '}
                                              {data['produto-novo-id']} -{' '}
                                              {data['produto-novo-nome']}
                                            </Text>
                                            <Box
                                              p={4}
                                              pos="relative"
                                              h={380}
                                              maxW="100%"
                                              overflow="auto"
                                            >
                                              <Table
                                                size="sm"
                                                style={{
                                                  borderCollapse: 'separate',
                                                  maxHeight: 20
                                                }}
                                                className="scl-table-grid"
                                              >
                                                <Thead
                                                  style={{
                                                    background: '#EDF2F7',
                                                    position: 'sticky',
                                                    top: -20,
                                                    zIndex: 1
                                                  }}
                                                >
                                                  <Tr
                                                    textTransform={'capitalize'}
                                                  >
                                                    <Th
                                                      textTransform={
                                                        'capitalize'
                                                      }
                                                    >
                                                      Data
                                                    </Th>
                                                    <Th
                                                      textTransform={
                                                        'capitalize'
                                                      }
                                                    >
                                                      Usuario
                                                    </Th>
                                                    <Th
                                                      textTransform={
                                                        'capitalize'
                                                      }
                                                    >
                                                      Id Produto Similar Antigo
                                                    </Th>
                                                    <Th
                                                      textTransform={
                                                        'capitalize'
                                                      }
                                                    >
                                                      Desc Produto Similar
                                                      Antigo
                                                    </Th>
                                                    <Th
                                                      textTransform={
                                                        'capitalize'
                                                      }
                                                    >
                                                      Id Produto Similar Novo
                                                    </Th>
                                                    <Th
                                                      textTransform={
                                                        'capitalize'
                                                      }
                                                    >
                                                      Desc Produto Similar Novo
                                                    </Th>
                                                    <Th
                                                      textTransform={
                                                        'capitalize'
                                                      }
                                                    >
                                                      Demanda Absorvida Antiga
                                                    </Th>
                                                    <Th
                                                      textTransform={
                                                        'capitalize'
                                                      }
                                                    >
                                                      Demanda Absorvida Nova
                                                    </Th>
                                                    <Th
                                                      textTransform={
                                                        'capitalize'
                                                      }
                                                    >
                                                      Data Inicio Antiga
                                                    </Th>
                                                    <Th
                                                      textTransform={
                                                        'capitalize'
                                                      }
                                                    >
                                                      Data Inicio Nova
                                                    </Th>
                                                    <Th
                                                      textTransform={
                                                        'capitalize'
                                                      }
                                                    >
                                                      Data Fim Antiga
                                                    </Th>
                                                    <Th
                                                      textTransform={
                                                        'capitalize'
                                                      }
                                                    >
                                                      Data Fim Nova
                                                    </Th>
                                                  </Tr>
                                                </Thead>
                                                <Tbody>
                                                  {dataHistoricUpdate.length ===
                                                  0 ? (
                                                    <Tr>
                                                      <Td
                                                        colSpan={16}
                                                        align="center"
                                                      >
                                                        Dados não encontrados
                                                      </Td>
                                                    </Tr>
                                                  ) : (
                                                    dataHistoricUpdate.map(
                                                      value => (
                                                        <>
                                                          <Tr>
                                                            <Td>
                                                              {value?.criadoEm
                                                                ? format(
                                                                    parseISO(
                                                                      value?.criadoEm.toString()
                                                                    ),
                                                                    'dd/MM/yyyy HH:mm:ss'
                                                                  )
                                                                : ''}
                                                            </Td>
                                                            <Td>
                                                              {value?.idUsuario}
                                                            </Td>
                                                            <Td>
                                                              {
                                                                value?.productSimilarOld
                                                              }
                                                            </Td>
                                                            <Td>
                                                              {
                                                                value?.productSimilarOldDescription
                                                              }
                                                            </Td>
                                                            <Td>
                                                              {
                                                                value?.productSimilarNew
                                                              }
                                                            </Td>
                                                            <Td>
                                                              {
                                                                value?.productSimilarNewDescription
                                                              }
                                                            </Td>
                                                            <Td>
                                                              {value?.demandOld}
                                                            </Td>
                                                            <Td>
                                                              {value?.demandNew}
                                                            </Td>
                                                            <Td>
                                                              {
                                                                value?.dataInicioOld
                                                              }
                                                            </Td>
                                                            <Td>
                                                              {
                                                                value?.dataInicioNew
                                                              }
                                                            </Td>
                                                            <Td>
                                                              {
                                                                value?.dataFimOld
                                                              }
                                                            </Td>
                                                            <Td>
                                                              {
                                                                value?.dataFimNew
                                                              }
                                                            </Td>
                                                          </Tr>
                                                        </>
                                                      )
                                                    )
                                                  )}
                                                </Tbody>
                                              </Table>
                                            </Box>
                                          </>
                                        )}
                                      </TabPanel>
                                    )}
                                  </TabPanels>
                                </Tabs>
                              ) : (
                                <Box>
                                  <Flex
                                    flexDir="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    bg="white"
                                    borderRadius="8px"
                                    h="calc(30vh - 128px)"
                                    p={8}
                                  >
                                    <Text
                                      maxW="460px"
                                      fontSize={18}
                                      textAlign="center"
                                    >
                                      Não existe registro de alterações para o
                                      centro {data['centro-codigo']} e o produto{' '}
                                      {data['produto-id']}.
                                    </Text>
                                  </Flex>
                                </Box>
                              )}
                            </>
                          )}

                          <Center>
                            <Box
                              p={2}
                              alignItems="center"
                              alignContent="center"
                            >
                              <Button
                                colorScheme="red"
                                mr={3}
                                onClick={onClose}
                              >
                                Fechar
                              </Button>
                            </Box>
                          </Center>
                        </ModalBody>
                      </ModalContent>
                    </Modal>
                    <IconButton
                      key={`table-action-${index}`}
                      aria-label="Abrir modal t"
                      icon={action.icon}
                      size="xs"
                      onClick={() => {
                        getHistoricUpdate(data['id-id'])
                        onOpen()
                      }}
                      _hover={{
                        bg: 'yellow.200'
                      }}
                      _active={{
                        bg: 'yellow.100'
                      }}
                    />
                  </>
                )
              }

              if (action.type === 'checkbox') {
                if (action.isMulti) {
                  return (
                    <>
                      <Checkbox
                        key={`table-action-${index}`}
                        colorScheme="red"
                        isChecked={action.selecteds.includes(data['id-id'])}
                        borderColor="blackAlpha.400"
                        alignItems="center"
                        onChange={() => {
                          if (action.onChange) {
                            action.onChange(data)
                          }
                        }}
                      />
                    </>
                  )
                } else {
                  return (
                    <Checkbox
                      key={`table-action-${index}`}
                      colorScheme="yellow"
                      isChecked={action.isChecked}
                      borderColor="blackAlpha.400"
                      alignItems="center"
                      isDisabled={
                        action.selecteds !== 0
                          ? action.selecteds !== data['id-id']
                          : false
                      }
                      onChange={() => {
                        if (action.onChange) {
                          action.onChange(data)
                        }
                      }}
                    />
                  )
                }
              }
            })}
          </HStack>
        </td>
      )}
      {rows.map(({ id, value, align, isNumeric }, key) => (
        <td key={`${id}-${key}`} align={align || 'left'}>
          <Box
            justifyContent={isNumeric ? 'center' : null}
            textAlign={isNumeric ? 'center' : null}
          >
            {query.length > 0 ? (
              <Highlighter
                searchWords={String(query).split(' ')}
                textToHighlight={String(value)}
              />
            ) : (
              value
            )}
          </Box>
        </td>
      ))}
    </tr>
  )
}

export default TableGridParametrizationIncrementItem
